import { Box } from '@mui/material';
import { BuilderVocabularyItem } from '../../types/SimilarlySituated/BuilderVocabularyItem.type';

interface PillGroupProps {
  options: BuilderVocabularyItem[];
  selectedIds: number[];
  onChange: (option: BuilderVocabularyItem) => void;
  disabled?: boolean;
}

function PillGroup({ options, selectedIds, onChange, disabled }: PillGroupProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {options.map((option) => {
        const isSelected = selectedIds.includes(option.id);

        return (
          <Box
            key={option.id}
            component='button'
            type='button'
            disabled={disabled}
            onClick={() => onChange(option)}
            sx={{
              borderRadius: '24px',
              border: `1px solid ${isSelected ? '#7DD3FC' : '#A0AEC0'}`,
              backgroundColor: isSelected ? '#E0F2FE' : '#fff',
              color: isSelected ? '#0369A1' : '#4A5568',
              fontSize: '13px',
              fontWeight: isSelected ? 500 : 400,
              padding: '8px 16px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease-in-out',
              '&:hover': { borderColor: isSelected ? 'none' : '#CBD5E0', color: isSelected ? '#0369A1' : '#6e7478' },
            }}
          >
            {option.name}
          </Box>
        );
      })}
    </Box>
  );
}

export default PillGroup;
